import React from 'react';
import ServiceDetailPage from '../ServiceDetailPage';

const copyTradingConfig = {
  pageClass: 'copy-detail-page',
  eyebrow: 'Copy trading',
  title: 'Verified copy trading access.',
  copy: 'This route is for users willing to complete the Blofin setup, deposit, first trade, and UID proof flow before CRYPTOXNFT access is reviewed.',
  actions: [
    { label: 'Create Blofin Account', href: 'https://partner.blofin.com/d/CRYPTOXNFT' },
    { label: 'Open Discord Ticket', href: 'https://discord.com/invite/7aUjfaaQ6v', variant: 'secondary' },
    { label: 'Free Telegram', href: 'https://t.me/cryptoxnfts', variant: 'ghost' },
  ],
  metrics: [
    { value: '$100+', label: 'Deposit path', note: 'Current flow' },
    { value: 'UID', label: 'Verification', note: 'Ticket review' },
    { value: 'VIP', label: 'Access layer', note: 'After approval' },
  ],
  visual: {
    kicker: 'COPY DESK',
    badge: 'BLOFIN',
    label: 'Copy trading access preview',
    rows: [
      { label: 'Account', title: 'Partner signup', meta: 'Step 1' },
      { label: 'Trade', title: 'Funded proof', meta: '$100+' },
      { label: 'Ticket', title: 'UID review', meta: 'Manual' },
    ],
    chips: ['Blofin path', 'Deposit proof', 'Discord ticket', 'VIP unlock'],
    media: {
      src: '/assets/images/services/copy/profitcard.png',
      alt: 'Historical copy trading profit card',
      label: 'Historical copy trading preview',
    },
  },
  featuresIntro: {
    eyebrow: 'What this route is',
    title: 'Account setup first, access after proof.',
    copy: 'There is no simple payment page here. The product is a verification route tied to a partner account flow.',
  },
  features: [
    {
      label: 'Signup',
      title: 'Blofin route',
      copy: 'Create the account through the CRYPTOXNFT partner destination or code.',
    },
    {
      label: 'Proof',
      title: 'UID review',
      copy: 'Submit your Blofin UID through Discord or Telegram so access can be checked.',
    },
    {
      label: 'Unlock',
      title: 'VIP layer',
      copy: 'Approved users can receive the resource layer connected to the copy route.',
    },
  ],
  flowIntro: {
    eyebrow: 'Verification flow',
    title: 'Complete the proof path before access.',
    copy: 'The steps are explicit so users know the friction before they create an account or deposit funds.',
  },
  steps: [
    {
      title: 'Join Telegram first',
      copy: 'Understand the style and daily context before committing to setup.',
    },
    {
      title: 'Create Blofin account',
      copy: 'Use the partner link or CRYPTOXNFT promo path so the account can qualify.',
    },
    {
      title: 'Deposit and trade',
      copy: 'Fund the account, place the required first trade, then keep the UID ready.',
    },
    {
      title: 'Submit UID proof',
      copy: 'Open a Discord ticket or message admin for manual review.',
    },
  ],
  proofIntro: {
    eyebrow: 'Historical proof',
    title: 'Examples are visible before users start setup.',
    copy: 'The screenshots show historical result previews and VIP resource context tied to the route.',
  },
  proofItems: [
    {
      src: '/assets/images/services/copy/pnl/profit1.jpg',
      alt: 'Historical copy trading proof screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/copy/pnl/profit2.jpg',
      alt: 'Historical copy trading proof screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/copy/pnl/profit3.jpg',
      alt: 'Historical copy trading proof screenshot',
      label: 'Historical example',
    },
    {
      src: '/assets/images/services/copy/vip/1.png',
      alt: 'VIP resource preview screenshot',
      label: 'VIP resource preview',
    },
    {
      src: '/assets/images/services/copy/vip/5.png',
      alt: 'VIP resource preview screenshot',
      label: 'VIP resource preview',
    },
    {
      src: '/assets/images/services/copy/vip/9.png',
      alt: 'VIP resource preview screenshot',
      label: 'VIP resource preview',
    },
  ],
  notice: 'Copy trading includes market, execution, liquidity, and trader-selection risk. Keep control of allocation, leverage, and stop conditions.',
  finalCta: {
    eyebrow: 'Start here',
    title: 'Use the partner route, then submit proof.',
    copy: 'If you already qualify, send UID proof. If not, start with the official Blofin destination and the free Telegram context.',
    actions: [
      { label: 'Create Blofin Account', href: 'https://partner.blofin.com/d/CRYPTOXNFT' },
      { label: 'Open Discord', href: 'https://discord.com/invite/7aUjfaaQ6v', variant: 'secondary' },
      { label: 'Trader Details', href: 'https://blofin.com/copy-trade/details/27438838297', variant: 'ghost' },
    ],
  },
};

function CopyTrading() {
  return <ServiceDetailPage {...copyTradingConfig} />;
}

export default CopyTrading;
